import { fg } from '@atlassian/jira-feature-gating';
import { boardRelayResource } from '@atlassian/jira-router-resources-board-resource/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const conditionalBoardRelayResource = resourceWithCondition2(
	() => fg('critical_board_query_with_relay'),
	boardRelayResource,
);
